import { render, staticRenderFns } from "./admin.orders.vue?vue&type=template&id=de79fc3e&"
import script from "./admin.orders.vue?vue&type=script&lang=js&"
export * from "./admin.orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports